import type {BulkDeal, ExclusiveDeal, GiftDeal} from './ProductDeals';

export const DealType = {
  BULK_DEAL: 'BULK_DEAL',
  EXCLUSIVE_DEAL: 'EXCLUSIVE_DEAL',
  GIFT_DEAL: 'GIFT_DEAL',
}

export interface DealSelection {
  type: DealType;
  value: BulkDeal | ExclusiveDeal | GiftDeal;
}